// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1_mmB","right":"styles_right__3YknN"};